import Modal from 'react-bootstrap/Modal';
import Button from '../Button';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import useMobile from '../../hooks/useMobileHook';

export type EOICompleteModalProps = {
  showModal: boolean;
  handleClose: () => void;
};

const EOICompleteModal = ({
  showModal,
  handleClose,
}: EOICompleteModalProps) => {
  const isMobile = useMobile();
  return (
    <>
      <Modal
        fullscreen={isMobile}
        show={showModal}
        onHide={handleClose}
        size={'xl'}
        className={'my-auto'}
      >
        <Modal.Header className={'border-0  border-bottom'} closeButton>
          <Modal.Title className="h6 fw-normal text-start">
            <h4>Complete your EOI online</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={'mt-10 mb-10 pt-7 pb-5'}>
          <span className={'fw-light lh-xs text-fs-6'}>
            Based on your recent Life Insurance election, you are required to
            complete an evidence of insurance (EOI) on the insurance carrier’s
            (MetLife) website. Please keep in mind that your EOI must be
            completed and approved by MetLife before you are enrolled in your
            elected level of coverage.
          </span>
        </Modal.Body>
        <Modal.Footer className={'pt-1'}>
          <Button variant={'primary-outline'} onMouseDown={handleClose}>
            Cancel
          </Button>
          <Button
            variant={'primary'}
            onMouseDown={() => {
              window.open(
                'https://www.metlife.com/global-employee-benefits/globally-mobile-solutions/employee-experience/online-tools-and-support/ '
              );
              handleClose();
            }}
            className="mb-7 mb-lg-0"
            leftIcon={light('external-link')}
          >
            Visit MetLife
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EOICompleteModal;
